import type { MouseEvent } from "react";
import classNames from "classnames";
import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";

export interface BoxProps {
  description?: string;
  handleClick: (
    name: string,
    multi: boolean,
    event: MouseEvent<HTMLButtonElement>,
  ) => void;
  icon?: { selected: IconType; default: IconType; viewBox: string };
  label?: string;
  multi?: boolean;
  name: string;
  value: string[];
}

export const Box = ({
  multi,
  label,
  name,
  description,
  icon,
  handleClick,
  value,
}: BoxProps) => {
  const isSelected = value.includes(name);

  return (
    <div
      className={classNames("react-checkbox__box", {
        "react-checkbox__box--selected": isSelected,
      })}
    >
      <button
        type="button"
        name={name}
        onClick={event => handleClick(name, multi ?? false, event)}
      >
        {label}
      </button>
      {icon && (
        <span className="react-checkbox__box-icon">
          <Icon
            type={isSelected ? icon.selected : icon.default}
            viewBox={icon.viewBox}
          />
        </span>
      )}
      <span className="react-checkbox__box-label">{label}</span>
      <span className="react-checkbox__box-description">{description}</span>
    </div>
  );
};
